<template>
    <div class="facilities__store knowledge-base__store">

        <div class="facilities__store-form-wrapper">
            <form action="#" class="facilities__store-form knowledge-base__store-form knowledge-base__store-form--open">


                <fieldset class="facilities__store-fieldset knowledge-base__store-fieldset d-flex">

                    <div class="facilities__store-fieldset-item knowledge-base__store-fieldset-item">
                        <input type="text" class="facilities__store-input knowledge-base__store-input" v-model="$v.storeForm.title.$model" :placeholder="$store.getters.t('facilities_store_form_title')">
                        <div class="field-error-text" v-if="$v.storeForm.title.$error">{{$store.getters.t('facilities_store_form_enter_title')}}</div>
                    </div>

                </fieldset>

                <fieldset class="facilities__store-fieldset knowledge-base__store-fieldset d-flex">

                    <div class="facilities__store-fieldset-item knowledge-base__store-fieldset-item">
                        <textarea type="text" class="facilities__store-input knowledge-base__store-input" v-model="$v.storeForm.description.$model" :placeholder="$store.getters.t('facilities_store_form_description')"></textarea>
                        <div class="field-error-text" v-if="$v.storeForm.description.$error">{{$store.getters.t('facilities_store_form_description_min')}}</div>
                    </div>

                </fieldset>

                <fieldset class="facilities__store-fieldset knowledge-base__store-fieldset d-flex">


                    <div class="facilities__store-fieldset-item knowledge-base__store-fieldset-item knowledge-base__store-fieldset-item--halfs-tags" style="position:relative;">
                        <input type="text" v-model="storeForm.citySearch" class="facilities__store-input knowledge-base__store-input" :placeholder="$store.getters.t('facilities_store_form_city')"
                               :disabled="this.storeForm.selectedRegions.length || storeForm.range === 'region' || storeForm.range === 'country' || storeForm.range === 'abroads'">
                        <div class="search-result search-result-store" v-if="storeForm.cities.length">
                            <div class="city-item" :class="{'city-item--added': !storeForm.selectedCities.length ? false : storeForm.selectedCities.some(e => e.id === city.id)}"
                                 v-for="city in storeForm.cities" @click="setStoreLocation('cities',city)">{{ city.name }}
                            </div>
                        </div>
                        <div class="search-result search-result-store" v-if="!storeForm.cities.length && storeForm.citySearch">
                            <div class="city-item">{{$store.getters.t('facilities_store_form_nothing_found')}}</div>
                        </div>

                        <ul class="knowledge-base__tags d-flex" v-if="storeForm.selectedCities.length">
                            <li class="knowledge-base__tags-item" v-for="(city, idx) in storeForm.selectedCities">
                                <span class="knowledge-base__tags-label" @click.prevent="deleteSelectedLocation('cities', idx)">{{ city.name }} &times;</span>
                            </li>
                        </ul>

                        <div class="field-error-text" v-if="$v.storeForm.selectedCities.$error">{{$store.getters.t('facilities_store_form_choose_city')}}</div>
                    </div>


                    <div class="facilities__store-fieldset-item knowledge-base__store-fieldset-item knowledge-base__store-fieldset-item--halfs-tags" style="position:relative;">
                        <input type="text" v-model="storeForm.regionSearch" class="facilities__store-input knowledge-base__store-input" :placeholder="$store.getters.t('facilities_store_form_region')"
                               :disabled="this.storeForm.selectedCities.length || storeForm.range === 'city' || storeForm.range === 'country' || storeForm.range === 'abroads'">
                        <div class="search-result search-result-store" v-if="storeForm.regions.length">
                            <div class="city-item" :class="{'city-item--added': !storeForm.selectedRegions.length ? false : storeForm.selectedRegions.some(e => e.id === region.id)}"
                                 v-for="region in storeForm.regions" @click="setStoreLocation('regions',region)">{{ region.name }}
                            </div>
                        </div>
                        <div class="search-result search-result-store" v-if="!storeForm.regions.length && storeForm.regionSearch">
                            <div class="city-item">{{$store.getters.t('facilities_store_form_nothing_found')}}</div>
                        </div>

                        <ul class="knowledge-base__tags d-flex" v-if="storeForm.selectedRegions.length">
                            <li class="knowledge-base__tags-item" v-for="(region, idx) in storeForm.selectedRegions">
                                <span class="knowledge-base__tags-label" @click.prevent="deleteSelectedLocation('regions', idx)">{{ region.name }} &times;</span>
                            </li>
                        </ul>

                        <div class="field-error-text" v-if="$v.storeForm.selectedRegions.$error">{{$store.getters.t('facilities_store_form_choose_region')}}</div>
                    </div>


                </fieldset>


                <fieldset class="facilities__store-fieldset knowledge-base__store-fieldset d-flex">
                    <div class="facilities__store-fieldset-item knowledge-base__store-fieldset-item" v-if="pageType === 'photo-n-pr'">
                        <p class="facilities__store-label knowledge-base__store-label">{{$store.getters.t('facilities_store_form_service_type')}}</p>
                        <div class="custom-radio">
                            <input type="radio" id="type_photo_help" :disabled="type === 'UPDATE'" v-model="$v.storeForm.type.$model" value="photo_help" name="type">
                            <label for="type_photo_help">
                                <span class="circle"></span>
                                {{$store.getters.t('facilities_store_form_photo_help')}}
                            </label>
                        </div>
                        <div class="custom-radio">
                            <input type="radio" id="type_pr_help" :disabled="type === 'UPDATE'" v-model="$v.storeForm.type.$model" value="pr_help" name="type">
                            <label for="type_pr_help">
                                <span class="circle"></span>
                                {{$store.getters.t('facilities_store_form_pr')}}
                            </label>
                        </div>
                        <div class="field-error-text" v-if="$v.storeForm.type.$error">{{$store.getters.t('facilities_store_form_enter_type')}}</div>
                    </div>

                    <div class="facilities__store-fieldset-item knowledge-base__store-fieldset-item" v-if="pageType === 'auto-help'">
                        <p class="facilities__store-label knowledge-base__store-label">{{$store.getters.t('facilities_store_form_service_type')}}</p>
                        <div class="custom-radio">
                            <input type="radio" id="type_auto_help" :disabled="type === 'UPDATE'" v-model="$v.storeForm.type.$model" value="auto_help" name="type">
                            <label for="type_auto_help">
                                <span class="circle"></span>
                                {{$store.getters.t('facilities_store_form_auto_help')}}
                            </label>
                        </div>
                        <div class="field-error-text" v-if="$v.storeForm.type.$error">{{$store.getters.t('facilities_store_form_enter_type')}}</div>
                    </div>

                    <div class="facilities__store-fieldset-item knowledge-base__store-fieldset-item" v-if="pageType === 'giveaway'">
                        <p class="facilities__store-label knowledge-base__store-label">{{$store.getters.t('facilities_store_form_service_type')}}</p>
                        <div class="custom-radio">
                            <input type="radio" id="type_giveaway" :disabled="type === 'UPDATE'" v-model="$v.storeForm.type.$model" value="giveaway" name="type">
                            <label for="type_giveaway">
                                <span class="circle"></span>
                                {{$store.getters.t('facilities_store_form_giveaway')}}
                            </label>
                        </div>
                        <div class="field-error-text" v-if="$v.storeForm.type.$error">{{$store.getters.t('facilities_store_form_enter_type')}}</div>
                    </div>


                    <div class="facilities__store-fieldset-item knowledge-base__store-fieldset-item">
                        <p class="facilities__store-label knowledge-base__store-label">{{$store.getters.t('facilities_store_form_availability')}}</p>
                        <div class="custom-radio">
                            <input type="radio" id="range_city" v-model="$v.storeForm.range.$model"
                                   value="city" name="range">
                            <label for="range_city">
                                <span class="circle"></span>
                                {{$store.getters.t('facilities_store_form_city')}}
                            </label>
                        </div>
                        <div class="custom-radio">
                            <input type="radio" id="range_region" v-model="$v.storeForm.range.$model"
                                   value="region" name="range">
                            <label for="range_region">
                                <span class="circle"></span>
                                {{$store.getters.t('facilities_store_form_region')}}
                            </label>
                        </div>
                        <div class="custom-radio">
                            <input type="radio" id="range_country" v-model="$v.storeForm.range.$model"
                                   value="country" name="range">
                            <label for="range_country">
                                <span class="circle"></span>
                                {{$store.getters.t('facilities_store_form_country')}}
                            </label>
                        </div>
                        <div class="custom-radio">
                            <input type="radio" id="range_abroads" v-model="$v.storeForm.range.$model"
                                   value="abroads" name="range">
                            <label for="range_abroads">
                                <span class="circle"></span>
                                {{$store.getters.t('facilities_store_form_abroad')}}
                            </label>
                        </div>
                        <div class="field-error-text" v-if="$v.storeForm.range.$error">{{$store.getters.t('facilities_store_form_enter_availability')}}</div>
                    </div>
                </fieldset>

                <fieldset class="facilities__store-fieldset knowledge-base__store-fieldset d-flex" v-if="pageType !== 'giveaway'">

                    <div class="facilities__store-fieldset-item knowledge-base__store-fieldset-item">
                        <p class="facilities__store-label knowledge-base__store-label">{{$store.getters.t('facilities_store_form_pricing')}}</p>
                        <div class="custom-radio">
                            <input type="radio" id="charge_free" v-model="$v.storeForm.chargeCategory.$model" value="free" name="charge">
                            <label for="charge_free">
                                <span class="circle"></span>
                                {{$store.getters.t('facilities_store_form_free')}}
                            </label>
                        </div>
                        <div class="custom-radio">
                            <input type="radio" id="charge_paid" v-model="$v.storeForm.chargeCategory.$model" value="paid_for" name="charge">
                            <label for="charge_paid">
                                <span class="circle"></span>
                                {{$store.getters.t('facilities_store_form_paid')}}
                            </label>
                        </div>
                        <div class="custom-radio">
                            <input type="radio" id="charge_cost_recovery" v-model="$v.storeForm.chargeCategory.$model" value="cost_recovery" name="charge">
                            <label for="charge_cost_recovery">
                                <span class="circle"></span>
                                {{$store.getters.t('facilities_store_form_cost_recovery')}}
                            </label>
                        </div>
                        <div class="field-error-text" v-if="$v.storeForm.chargeCategory.$error">{{$store.getters.t('facilities_store_form_choose_tariff')}}</div>
                    </div>

                </fieldset>

                <fieldset class="facilities__store-fieldset knowledge-base__store-fieldset d-flex" v-if="pageType === 'giveaway'">

                    <div class="facilities__store-fieldset-item knowledge-base__store-fieldset-item">
                        <p class="facilities__store-label knowledge-base__store-label">{{$store.getters.t('facilities_store_form_category')}}</p>
                        <div class="custom-radio">
                            <input type="radio" id="giveaway_store_medical" v-model="$v.storeForm.giveawayCategory.$model" value="medical" name="giveawayCategory">
                            <label for="giveaway_store_medical">
                                <span class="circle"></span>
                                {{$store.getters.t('facilities_store_form_medical')}}
                            </label>
                        </div>
                        <div class="custom-radio">
                            <input type="radio" id="giveaway_store_nutrition" v-model="$v.storeForm.giveawayCategory.$model" value="nutrition" name="giveawayCategory">
                            <label for="giveaway_store_nutrition">
                                <span class="circle"></span>
                                {{$store.getters.t('facilities_store_form_nutrition')}}
                            </label>
                        </div>
                        <div class="custom-radio">
                            <input type="radio" id="giveaway_store_other" v-model="$v.storeForm.giveawayCategory.$model" value="other" name="giveawayCategory">
                            <label for="giveaway_store_other">
                                <span class="circle"></span>
                                {{$store.getters.t('facilities_store_form_other')}}
                            </label>
                        </div>
                        <div class="field-error-text" v-if="$v.storeForm.giveawayCategory.$error">{{$store.getters.t('facilities_store_form_choose_category')}}</div>
                    </div>

                </fieldset>


                <fieldset class="facilities__store-fieldset knowledge-base__store-fieldset d-flex">

                    <div class="facilities__store-fieldset-item knowledge-base__store-fieldset-item">
                        <div class="upload_wrapper">
                            <div class="row text-center">

                                <div class="col-12 col-md-6">
                                    <div class="custom_upload">
                                        <label for="screenshot">
                                            <input type="file" id="screenshot" name="photos" class="files w-100" accept=".png,.jpeg,.jpg,.gif"
                                                   @change="handleFileUpload" multiple>
                                            <span class="btn">{{$store.getters.t('facilities_store_form_choose_photos')}}</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="col-12 col-md-6">
                                    <button type="submit" @click.prevent="storePost" class="btn"
                                            :style="{backgroundColor: storeFormStatus.color}"
                                            :disabled="storeStatus === 'pending'">{{ storeFormStatus.text }}
                                    </button>
                                </div>

                            </div>
                        </div>

                        <template v-if="type === 'UPDATE' && serverImages.length">
                            <div class="row mt-4 update-image">
                                <div class="col-md-12">
                                    <p>{{$store.getters.t('facilities_store_form_photos_already_uploaded')}}</p>
                                </div>
                                <div class="col-6 col-sm-4 col-md-3" v-for="(image, idx) in serverImages">
                                    <div class="row">
                                        <div class="col-12">
                                            <img :src="`/storage${image.path.replace('original', 'preview_l')}`" alt="" class="w-100">
                                            <span class="lnr upload_cross lnr-cross" style="cursor:pointer;" @click="deleteServerPhoto(idx, image.id)"></span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </template>

                        <template v-if="storeForm.previewImages.length">

                            <div class="row mt-4 update-image" v-for="(image, index) in storeForm.previewImages">
                                <div class="col-5 col-md-3">
                                    <img :src="image.base64" alt="" class="w-100">
                                    <span class="lnr upload_cross lnr-cross" style="cursor:pointer;" @click="deletePhoto(index)"></span>
                                </div>
                                <div class="col-7 col-md-9" style="word-break: break-word;">
                                    {{ image.name }}
                                </div>
                            </div>
                        </template>
                    </div>
                </fieldset>


            </form>
        </div>

    </div>
</template>

<script>

import {required, numeric, minValue, maxLength, minLength, requiredIf} from 'vuelidate/lib/validators';


export default {
    name: "StoreForm",
    props: ['type', 'updateOBJ', 'pageType'],
    data() {
        return {
            appRoutes: null,
            petsCategories: [],
            storeStatus: 'waiting_to_send',
            storeForm: {
                citySearch: null,
                selectedCities: [],
                cities: [],

                regionSearch: null,
                selectedRegions: [],
                regions: [],

                type: null,
                title: null,
                description: null,
                chargeCategory: null,
                giveawayCategory: null,
                range: null,

                deleteImagesIds: [],

                previewImagesOnlyBase64: [],
                previewImages: [],
                images: [],
            },

            serverImages: []
        }
    },


    mounted() {


        if (this.pageType === 'auto-help') this.storeForm.type = 'auto_help'

        if (this.pageType === 'giveaway') this.storeForm.type = 'giveaway'

        if ((this.type === 'UPDATE' && Object.keys(this.updateOBJ).length)) {


            this.storeForm = (({cities, regions, type, name, description, charge_category, range, giveaway_category = null}) => (
                {
                    selectedCities: cities,
                    selectedRegions: regions,
                    type,
                    title: name,
                    description,
                    chargeCategory: charge_category,
                    giveawayCategory: giveaway_category,
                    range,

                    previewImagesOnlyBase64: [],
                    previewImages: [],
                    images: [],
                    deleteImagesIds: [],
                    regions: [],
                    regionSearch: null,
                    cities: [],
                    citySearch: null,


                }
            ))(this.updateOBJ)

            this.serverImages = this.updateOBJ.images || []

        }

    },

    computed: {

        storeType() {
            let type = this.storeForm.type

            switch (type) {
                case 'photo_help':
                    type = 'photo-help'
                    break;
                case 'pr_help':
                    type = 'pr-help'
                    break;
                case 'auto_help':
                    type = 'auto-help'
                    break;
                case 'giveaway':
                    type = 'giveaway'
                    break;
                default:
                    type = null
            }

            return type


        },

        storeFormStatus() {

            let result = {}

            switch (this.storeStatus) {
                case 'success':
                    result = {
                        color: '#77de51',
                        text: this.$store.getters.t('facilities_store_form_status_sent')
                    }
                    break;
                case 'failed':
                    result = {
                        color: '#EE7372',
                        text: this.$store.getters.t('facilities_store_form_status_error')
                    }
                    break;
                default:
                    result = {
                        color: '#0674ec',
                        text: this.$store.getters.t('facilities_store_form_status_send')
                    }
            }

            return result

        },
    },

    watch: {
        'storeForm.selectedCities': function () {

            if (this.storeForm.selectedCities.length) {
                this.storeForm.selectedRegions = []
                this.storeForm.regions = []
                this.storeForm.regionSearch = null

                return this.storeForm.range = 'city'
            }

        },

        'storeForm.selectedRegions': function () {
            if (this.storeForm.selectedRegions.length) {
                this.storeForm.selectedCities = []
                this.storeForm.cities = []
                this.storeForm.citySearch = null

                this.storeForm.range = 'region'
            }
        },

        'storeForm.range': function () {
            if (this.storeForm.range === 'country' || this.storeForm.range === 'abroads') {

                this.storeForm.selectedCities = this.storeForm.selectedRegions = []
                this.storeForm.cities = this.storeForm.regions = []
                this.storeForm.citySearch = this.storeForm.regionSearch = null

            }


        },

        'storeForm.regionSearch': function (value) {
            if (!value) {

                this.storeForm.regions = []

                return
            }

            this.searchLocations('regions');
        },

        'storeForm.citySearch': function (value) {
            if (!value) {

                this.storeForm.cities = []

                return
            }

            this.searchLocations('cities');
        },

        'storeForm.images': function () {
            let self = this;

            if (self.noReloadPreview) {
                self.noReloadPreview = false;
                return false
            }

            self.storeForm.images.forEach(function (image) {
                if (typeof FileReader === "function") {
                    const reader = new FileReader();

                    reader.onload = event => {
                        if ($.inArray(event.target.result, self.storeForm.previewImagesOnlyBase64) === -1) {
                            self.storeForm.previewImages.push({
                                'base64': event.target.result,
                                'name': image.name,
                            });
                            self.storeForm.previewImagesOnlyBase64.push(event.target.result);
                        }
                    };

                    reader.readAsDataURL(image);
                }
            });
        },

    },

    methods: {
        storePost() {

            let self = this,
                url = (this.type === 'UPDATE' && Object.keys(this.updateOBJ).length) ?
                    `/api/facilities/${this.storeType}/${this.updateOBJ.id}?_method=PUT` : `/api/facilities/${this.storeType}`;

            self.$v.$touch();
            if (self.$v.storeForm.$invalid) {
                self.storeStatus = 'waiting_to_send';
                return false;
            }

            this.storeStatus = 'pending';

            let data = new FormData();

            data.append('type', self.storeForm.type);
            data.append('name', self.storeForm.title);
            data.append('description', self.storeForm.description);
            data.append('range', self.storeForm.range);

            if (this.pageType !== 'giveaway') {
                data.append('charge_category', self.storeForm.chargeCategory);
            }

            if (this.pageType === 'giveaway') {
                data.append('giveaway_category', self.storeForm.giveawayCategory);
            }

            if (self.storeForm.range === 'city' && self.storeForm.selectedCities.length) {
                self.storeForm.selectedCities.forEach(item => {
                    data.append('cities[]', item.id);
                })
            }

            if (self.storeForm.range === 'region' && self.storeForm.selectedRegions.length) {
                self.storeForm.selectedRegions.forEach(item => {
                    data.append('regions[]', item.id);
                })
            }

            if (self.storeForm.previewImagesOnlyBase64.length) {
                self.storeForm.previewImagesOnlyBase64.forEach(function (base64) {
                    let block = base64.split(";");
                    let contentType = block[0].split(":")[1];
                    let realData = block[1].split(",")[1];
                    let blob = self.b64toBlob(realData, contentType);
                    data.append('images[]', blob)
                });
            }

            if (self.type === "UPDATE" && self.storeForm.deleteImagesIds.length) {

                self.storeForm.deleteImagesIds.forEach(function (item) {
                    data.append('delete_images_ids[]', item);
                })

            }


            axios.post(url, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(res => {
                    res = res.data

                    if (res.success) {
                        self.storeStatus = 'success';

                        let eventName = '';

                        switch (this.pageType) {
                            case 'auto_help':
                                eventName = 'auto_help';
                                break;
                            case 'photo-n-pr':
                                eventName = 'photo_help';
                                break;
                            case 'giveaway':
                                eventName = 'give_away_help';
                                break;
                        }

                        if (eventName) {
                            window.dataLayer = window.dataLayer || [];
                            dataLayer.push({
                                'event': eventName
                            })
                        }

                        setTimeout(() => {
                            self.storeForm = {
                                citySearch: null,
                                selectedCities: [],
                                cities: [],

                                regionSearch: null,
                                selectedRegions: [],
                                regions: [],

                                type: null,
                                title: null,
                                description: null,
                                chargeCategory: null,
                                giveawayCategory: null,

                                range: null,

                                deleteImagesIds: [],

                                previewImagesOnlyBase64: [],
                                previewImages: [],
                                images: [],
                            }

                            if (this.pageType === 'auto-help') self.storeForm.type = 'auto_help'

                            if (this.pageType === 'giveaway') self.storeForm.type = 'giveaway'


                            self.$v.storeForm.$reset()
                            self.storeStatus = 'waiting_to_send';

                        }, 1000)


                    } else {
                        self.storeStatus = 'failed';

                        setTimeout(function () {
                            self.storeStatus = 'waiting_to_send';
                        }, 3000);
                    }


                })
                .catch(error => {
                    error = error.response.data

                    if (error) {
                        self.storeStatus = 'failed';
                        console.log(error)
                        alert(error.message)
                    }

                })
                .then(() => {

                    if ((this.type === 'UPDATE' && Object.keys(this.updateOBJ).length)) {
                        this.$emit('updateForm')
                        return
                    }

                    this.$emit('storeForm')
                })


        },


        deleteSelectedLocation(type, idx) {

            if (type === 'regions') {

                this.storeForm.selectedRegions.splice(idx, 1)

                if (!this.storeForm.selectedRegions.length) this.storeForm.range = null

                return
            }

            this.storeForm.selectedCities.splice(idx, 1)

            if (!this.storeForm.selectedCities.length) this.storeForm.range = null
        },

        setStoreLocation(type, item) {

            if (type === 'regions') {

                this.storeForm.selectedRegions.push(item);
                this.storeForm.regionSearch = null;
                this.storeForm.regions = [];

                return
            }

            this.storeForm.selectedCities.push(item);
            this.storeForm.citySearch = null;
            this.storeForm.cities = [];


        },

        searchLocations(type = 'cities', store = false) {
            let self = this;
            let url = `/api/locations/${type}`,
                params = {
                    city_id: null,
                    region_id: null,
                    country_id: null,
                    query: self.storeForm.citySearch
                }


            if (type === 'regions') params.query = self.storeForm.regionSearch

            if (store) {
                params = {
                    searchValue: self.storeForm.citySearch
                }
            }

            axios.get(url, {params: params})
                .then(response => {
                    response = response.data;
                    if (response.success) {

                        if (type === 'regions') return self.storeForm.regions = response.data

                        if (store) {
                            return self.storeForm.cities = response.data
                        }


                        self.storeForm.cities = response.data


                    }
                })
                .catch((error) => {
                    alert(this.$store.getters.t('common_error_reload'));
                })
        },


        handleFileUpload(e) {
            let self = this;
            let files = e.target.files;
            self.storeForm.images = [];


            for (let key in files) {

                if (e.target.files[key] instanceof File) {
                    self.storeForm.images.push(e.target.files[key]);
                }

            }
        },

        deleteServerPhoto(idx, idxServer) {

            this.storeForm.deleteImagesIds.push(idxServer)
            this.serverImages.splice(idx, 1)

        },


        deletePhoto(index) {
            let self = this;
            self.noReloadPreview = true;
            self.storeForm.previewImages.splice(index, 1);
            self.storeForm.images.splice(index, 1);
            self.storeForm.previewImagesOnlyBase64.splice(index, 1);
        },


        b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            let byteCharacters = atob(b64Data);
            let byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                let slice = byteCharacters.slice(offset, offset + sliceSize);

                let byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                let byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            return new Blob(byteArrays, {type: contentType});
        },


    },


    validations: {
        storeForm: {
            selectedCities: {
                required: requiredIf(function () {

                    if (this.storeForm.range === 'city') {
                        return true
                    }

                    return false
                }),
                minLength: minLength(1)
            },
            selectedRegions: {
                required: requiredIf(function () {

                    if (this.storeForm.range === 'region') {
                        return true
                    }

                    return false
                }),
                minLength: minLength(1)
            },
            type: {
                required
            },

            title: {
                required,
                maxLength: maxLength(256)
            },
            description: {
                required,
                minLength: minLength(30),
                maxLength: maxLength(1000)
            },
            chargeCategory: {
                required: requiredIf(function () {

                    if (this.pageType !== 'giveaway') return true

                    return false

                })
            },
            giveawayCategory: {
                required: requiredIf(function () {

                    if (this.pageType === 'giveaway') return true

                    return false

                })
            },
            range: {
                required,
            }
        }
    },
}
</script>

<style scoped>

</style>
